import { useState } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PaymentModal from '../../components/paymentModal/PaymentModal';
import { SttLabelDeleted } from './SttLabelDeleted';
import { formatPriceByLocale } from '../../lib/utils';

type Payment = {
    id: number;
    price: number;
    priceShape?: {
        currency?: string;
        locale?: string;
    };
    refund?: {
        id: number;
    };
};

type Props = {
    payment?: Payment | null;
    paymentDialogActive?: boolean;
    onClose?: () => void;
};

/**
 *    LABEL PAYMENT
 *    ==============
 */
export function SttLabelPayment({
    payment,
    paymentDialogActive = false,
    onClose,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const [openPaymentId, setOpenPaymentId] = useState<number | null>(null);

    return (
        <>
            <Box sx={{ textAlign: 'right' }}>
                {payment ? (
                    paymentDialogActive ? (
                        <Link
                            onClick={() => setOpenPaymentId(payment.id)}
                            underline="hover"
                            color="primary"
                            className="cursor-pointer"
                        >
                            {payment &&
                                formatPriceByLocale(
                                    payment.price,
                                    payment?.priceShape?.currency,
                                    payment?.priceShape?.locale,
                                )}
                        </Link>
                    ) : (
                        formatPriceByLocale(
                            payment.price,
                            payment?.priceShape?.currency,
                            payment?.priceShape?.locale,
                        )
                    )
                ) : (
                    <SttLabelDeleted />
                )}

                {payment?.refund?.id && (
                    <Box>
                        <Typography variant="caption">
                            {t('Returned')}
                        </Typography>
                    </Box>
                )}
            </Box>

            {paymentDialogActive && openPaymentId && (
                <PaymentModal
                    idPayment={openPaymentId}
                    onClose={() => {
                        setOpenPaymentId(null);
                        onClose?.();
                    }}
                    onPay={onClose}
                />
            )}
        </>
    );
}
